/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers/CreateToken/Content/Create/Title",
  onChange
  
}) {
let createTokenDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'create_token',
path: 'description',
})
let createTokenDescriptionChangeData = fromData.useDataChange({ viewPath,
context: 'create_token',
path: 'description',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 marginTop={0.1}
 data="create_token.description"
 value={createTokenDescriptionValueData}
 onChange={createTokenDescriptionChangeData}
 required={true}
 label="Description"
/>
{children}
</React.Fragment>)
}